import React from "react";
import { Desktop, Mobile } from "components/shared/breakpoints";
import { DesktopNavbar } from "./nav-desktop";
import { MobileNavbar } from "./nav-mobile";
import { useUserContext } from "contexts";

export const Navbar = ({
  dark,
  absolute,
}: {
  dark?: boolean;
  absolute?: boolean;
}) => {
  const [user] = useUserContext();

  const auth = user !== null && user.status === 0;
  const admin = user !== null && user.admin;
  if(user&&user.admin){
    localStorage.setItem("logout", "false");
  }else{
    localStorage.setItem("logout", "true");
  }

  return (
    <>
      <Desktop>
        <DesktopNavbar
          dark={dark}
          auth={auth}
          absolute={absolute}
          admin={admin}
        />
      </Desktop>
      <Mobile>
        <MobileNavbar dark={dark} auth={auth} absolute={absolute} admin={admin} />
      </Mobile>
    </>
  );
};

export default Navbar;
